<template lang="pug">
	VMain(scrollable)
		VContainer.fill-height
			VRow(justify="center")
				VCol(cols="12" md="9" lg="8")
					slot
</template>

<script lang="ts" setup>
useSkins().injectSkinClasses()
</script>
